<template>

  <v-container>
    <v-card :max-width="800" outlined class="mx-auto my-auto">
      <v-card-title>
        Getting Started Series
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col :cols="12">
            This step-by-step series of tutorials will help you become a Torvue power user in no time. Start on the right foot by watching/reading these resources first.
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="12">
            <div class="text-h6" style="color: black;">Getting Started Steps</div>
            <ol>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/branding">
                  <v-icon class="pr-2">mdi-numeric-1-box-outline</v-icon>
                  Setup Branding Profile
                </v-btn>
                <span class="caption font-italic">(2 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/unbox">
                  <v-icon class="pr-2">mdi-numeric-2-box-outline</v-icon>
                  Setup 360° Camera
                </v-btn>
                <span class="caption font-italic">(6 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/mobile">
                  <v-icon class="pr-2">mdi-numeric-3-box-outline</v-icon>
                  Connect Phone to Camera
                </v-btn>
                <span class="caption font-italic">(10 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/capture">
                  <v-icon class="pr-2">mdi-numeric-5-box-outline</v-icon>
                  Capture a Torvue
                </v-btn>

                <span class="caption font-italic">(5 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/uploader">
                  <v-icon class="pr-2">mdi-numeric-4-box-outline</v-icon>
                  Install Uploader
                </v-btn>

                <span class="caption font-italic">(2 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/learn/upload">
                  <v-icon class="pr-2">mdi-numeric-6-box-outline</v-icon>
                  Upload for Processing
                </v-btn>

                <span class="caption font-italic">(6 mins)</span>
              </li>
              <li>
                <v-btn small text color="primary" class="text-none pa-1" to="/checklist">
                  <v-icon class="pr-2">mdi-asterisk</v-icon>
                  Prerecord Checklist
                </v-btn>
              </li>
            </ol>
          </v-col>
        </v-row>
        <v-row>
          <div id="content-row" style="scroll-margin: 65px;" />
          <slot name="content" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <slot name="footer"/>
      </v-card-actions>
    </v-card>
  </v-container>

</template>

<script>
export default {
  name: "LearnLayout",
  data() {
    return {
      phone: null,
      phones: [
          'iPhone',
          'Android'
      ],
      computer: null,
      computers: [
        'Windows',
        'MacOS'
      ]
    }
  },
  methods: {
    // onChange() {
    //   const obj = {
    //     computer: this.computer,
    //     phone: this.phone
    //   }
    //
    //   localStorage.setItem('learn-filters', JSON.stringify(obj))
    //
    //   this.$emit('filter-change', obj)
    // }
  },
  mounted() {
    // const raw = localStorage.getItem('learn-filters')
    // if(raw) {
    //   const parsed = JSON.parse(raw)
    //   this.phone = parsed.phone
    //   this.computer = parsed.computer
    //   this.onChange()
    // }

    if(this.$route.path && !this.$route.path.endsWith('/learn/branding')) {
      setTimeout(() => {
        const element = document.getElementById('content-row')
        if(element) {
          console.log('scrolling!')
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }, 200)
    }

  }
}
</script>

<style scoped>
ol li {
  list-style: none;
}
</style>